export default "__VITE_ASSET__c0443c4c__"